import axiosInstance from '../../../_config/AxiosInstance';
import config from '../../../_config/config';
import { masterConstants } from '../../constant';

export const fetch_companies_action = () => async (dispatch) => {
  dispatch({
    type: masterConstants.FETCH_COMPANIES_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.master.company);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: masterConstants.FETCH_COMPANIES_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: masterConstants.FETCH_COMPANIES_ACTION_FAILURE,
      payload: e?.error,
    });
  }
};

export const create_company_action = (companyData) => async (dispatch) => {
  dispatch({
    type: masterConstants.CREATE_COMPANY_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(config.master.company, companyData);
    if (response.status) {
      let data = response.data;
      dispatch({
        type: masterConstants.CREATE_COMPANY_ACTION_SUCCESS,
        payload: data.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: masterConstants.CREATE_COMPANY_ACTION_FAILURE,
      payload: e?.error,
    });
  }
};
